module.exports = __webpack_public_path__ + "static/media/export.35c43826.svg";